// Scroll area on native overflow (no Radix ScrollArea, whose inline style element breaks the strict CSP): thin themed scrollbars, keyboard scrollable.
import type * as React from "react";

import { cn } from "@/lib/cn";

function ScrollArea({
  className,
  orientation = "vertical",
  ...props
}: React.ComponentProps<"div"> & { orientation?: "vertical" | "horizontal" | "both" }) {
  return (
    <div
      data-slot="scroll-area"
      className={cn(
        "min-h-0 min-w-0 [scrollbar-width:thin] [scrollbar-color:var(--b4)_transparent] overscroll-contain",
        orientation === "vertical" && "overflow-x-hidden overflow-y-auto",
        orientation === "horizontal" && "overflow-x-auto overflow-y-hidden",
        orientation === "both" && "overflow-auto",
        className,
      )}
      {...props}
    />
  );
}

export { ScrollArea };
